export default "__VITE_ASSET__CDKKN4CK__"